import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionOtherActorsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M20.533 1h-5v1h2v2h1V2h2V1zM11.173 14.302l-4.194-1.33V15.9l1.055.806v.793L6.2 16.976l-1.82.524v-.793l1.029-.806v-2.93l-4.17 1.33v-1.048l4.17-2.674V7.65c0-.221.075-.409.226-.562a.76.76 0 01.565-.23.74.74 0 01.559.23c.147.153.22.341.22.563v2.93l4.194 2.673v1.049zM23 14.302l-4.195-1.33V15.9l1.055.806v.793l-1.833-.524-1.821.524v-.793l1.03-.806v-2.93l-4.17 1.33v-1.048l4.17-2.674V7.65c0-.221.075-.409.226-.562a.76.76 0 01.565-.23.74.74 0 01.559.23c.146.153.22.341.22.563v2.93L23 13.252v1.049zM18.533 23H24v1H0v-1h5.706v-3h1v3h10.827v-3h1v3zM8.706 1h-5v1h2v2h1V2h2V1z'
        />
    ),
})

TaskInspectionOtherActorsIcon.displayName = 'TaskInspectionOtherActorsIcon'
